import { render, staticRenderFns } from "./LoadsReportTemplate.vue?vue&type=template&id=ea54466a"
import script from "./LoadsReportTemplate.vue?vue&type=script&lang=js"
export * from "./LoadsReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports